import { render } from "./Save.vue?vue&type=template&id=78bcc02a&scoped=true"
import script from "./Save.vue?vue&type=script&lang=js"
export * from "./Save.vue?vue&type=script&lang=js"

import "./Save.vue?vue&type=style&index=0&id=78bcc02a&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78bcc02a"]])

export default __exports__